import { Inject, Pipe, PipeTransform } from '@angular/core';
import { MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { Moment } from 'moment';
import { TimezoneDateAdapter } from '../TimezoneDateAdapter';


@Pipe({
    name: 'srpTimezoneDate',
    standalone: false
})
export class MatTimezoneDatePipe implements PipeTransform {
    constructor(
        @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
        private _dateAdapter: TimezoneDateAdapter,
    ) { }

    transform(value: Moment, format?: string): string {
        const date = this._dateAdapter.deserialize(value);
        return this._dateAdapter.format(date, format ?? this._dateFormats.display.dateInput);
    }
}

